import { useEffect, useRef } from 'react';

export const useDebouncedEffect = (
  effect: () => void | (() => void),
  deps: any[],
  { runOnFirstRender = true, delay = 500 } = {}
) => {
  const isFirstRender = useRef(true);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      if (!runOnFirstRender) return;
    }

    timeoutRef.current = setTimeout(() => {
      if (timeoutRef.current) {
        effect();
      }
    }, delay);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, delay]);
};
